<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  <!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <div class="visitor-card shadow border-primary mb-3">
          <div class="card-body">
            <fieldset class="border border-primary p-4 mb-4">
              <legend class="float-none w-auto letter-spacing-2">Create Question</legend>
              <div class="row mt-2 align-items-center">
                <!-- Question Input -->
                <div class="form-group col-md-6 mb-1 my-3">
                  <label class="text-secondary text-xxs">
                    Question<span class="text-danger">*</span>
                  </label>
                  <input type="text"
                        class="form-control text-xxs rounded p-2 bg-white"
                        v-model="newQuestion.text"
                        placeholder="Enter question text" />
                  <small class="text-danger" v-if="errors.newQuestion?.text">{{ errors.newQuestion.text }}</small>
                </div>

                <!-- Question Number Input -->
                <div class="form-group col-md-6 mb-1 my-3">
                  <label class="text-secondary text-xxs">
                    Question Number<span class="text-danger">*</span>
                  </label>
                  <input type="text"
                        class="form-control text-xxs rounded p-2 bg-white"
                        v-model="newQuestion.question_number"
                        placeholder="Eg. 1" />
                  <small class="text-danger" v-if="errors.newQuestion?.question_number">{{ errors.newQuestion.question_number }}</small>
                </div>

                <!-- Question Type Select -->
                <div class="form-group col-md-6 mb-1 my-3">
                  <label class="text-secondary text-xxs">
                    Type<span class="text-danger">*</span>
                  </label>
                  <select v-model="newQuestion.type" class="form-select text-xxs p-2 rounded">
                    <option value="" disabled selected>Select</option>
                    <option v-for="type in question_types" :key="type.id" :value="type.id">
                      {{ type.question_type }}
                    </option>
                  </select>
                  <small class="text-danger" v-if="errors.newQuestion?.type">{{ errors.newQuestion.type }}</small>

                  <!-- Options for Multiple Choice -->
                  <div v-if="newQuestion.type && question_types.find(t => t.id === newQuestion.type)?.question_type === 'multiple_choice'"
                      v-for="(option, index) in newQuestion.options"
                      :key="option.id"
                      class="d-flex align-items-center mb-2">
                    <input type="text"
                          class="form-control text-xxs rounded p-2 me-2"
                          v-model="option.text"
                          placeholder="Enter option text" />
                    <button class="btn btn-danger btn-sm text-xxs" type="button" @click="removeOption(index)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>

                  <!-- Options for Selection -->
                  <div v-if="newQuestion.type && question_types.find(t => t.id === newQuestion.type)?.question_type === 'selection'"
                      v-for="(option, index) in newQuestion.options"
                      :key="option.id"
                      class="d-flex align-items-center mb-2">
                    <input type="text"
                          class="form-control text-xxs rounded p-2 me-2"
                          v-model="option.text"
                          placeholder="Enter option text" />
                    <button class="btn btn-danger btn-sm text-xxs" type="button" @click="removeOption(index)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>

                  <!-- Options for Checkbox -->
                  <div v-if="newQuestion.type && question_types.find(t => t.id === newQuestion.type)?.question_type === 'checkbox'"
                      v-for="(option, index) in newQuestion.options"
                      :key="option.id"
                      class="d-flex align-items-center mb-2">
                    <input type="text"
                          class="form-control text-xxs rounded p-2 me-2"
                          v-model="option.text"
                          placeholder="Enter option text" />
                    <button class="btn btn-danger btn-sm text-xxs" type="button" @click="removeOption(index)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>

                  <!-- Add Option Button -->
                  <div v-if="newQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === newQuestion.type)?.question_type)">
                    <button class="btn btn-warning text-white mt-3 text-xxs rounded shadow-lg fw-500" type="button" @click="addOption">
                      <i class="bi bi-plus"></i> Add Question Option
                    </button>
                  </div>
                </div>

                <!-- Mandatory Field -->
                <div class="form-group col-md-6 mb-1 my-3">
                  <label class="text-secondary text-xxs">Is the question mandatory?</label>
                  <select v-model="newQuestion.is_mandatory" class="form-select text-xxs p-2 rounded">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>

                <!-- Locked Field -->
                <div class="form-group col-md-6 mb-1 my-3">
                  <label class="text-secondary text-xxs">Is the question locked?</label>
                  <select v-model="newQuestion.is_locked" class="form-select text-xxs p-2 rounded">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
                <div class="float-end">
                  <button type="button" class="btn btn-primary text-white text-xxs rounded shadow-lg fw-500 float-end" @click="createQuestion()">
                    Save
                  </button>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <!-- Questions Table -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body">
            <div v-show="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Question List...</p>
            </div>
            <div v-show="!isLoading">
            <fieldset class="border border-primary p-4 mb-4">
              <legend class="float-none w-auto letter-spacing-2">Questions List</legend>
              <button
                v-if="is_unassigning && is_ready_to_unassign"
                @click="submit_unassign"
                type="button"
                class="btn btn-primary text-white text-xxs rounded shadow-sm fw-500"
              >
                Save
              </button>
              <div class="table-responsive mt-2">
                <table class="table table-striped text-xxs mt-3">
                  <thead class="btn-primary text-white text-xxs">
                    <tr>
                      <th scope="col">#No</th>
                      <th scope="col">Question</th>
                      <th scope="col">Question Type</th>
                      <th scope="col">Options</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody class="text-black">
                    <tr
                      v-for="(question, index) in questions"
                      :key="question.id"
                      class="border-section text-xxs"
                    >
                      <th scope="row">{{ index + 1 }}</th>
                      <td>{{ question.question }}</td>
                      <td>{{ question.question_type.question_type }}</td>
                      <td>
                        <ul>
                          <li v-for="(opt, index) in question.options" :key="index">{{ opt.option }}</li>
                        </ul>
                      </td>

                      <td class="text-nowrap"> <div class="d-flex gap-1">
                        <button
                          class="btn btn-light btn-sm rounded text-success border text-xxs"
                          @click="openEditModal(question)">
                          Edit
                        </button>
                        <button
                          class="btn btn-light btn-sm rounded text-danger border text-xxs"
                          @click="delete_question(question.id)">
                          Delete
                        </button>
                      </div>
                    </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<teleport to="body">
  <!-- Edit Question Modal -->
  <div class="modal fade" id="edit_question_modal" tabindex="-1" aria-labelledby="edit_question_modal_label" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="exampleModalLabel">Edit Question
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="modal-body modal-body-scroll">
          <div class="row">
            <!-- Question Input -->
            <div class="form-group col-md-6 mb-1 my-3">
              <label class="text-secondary text-xxs">Question<span class="text-danger">*</span></label>
              <input type="text" class="form-control text-xxs rounded p-2 bg-white" v-model="editQuestion.text" placeholder="Enter question text" />
            </div>

            <!-- Question Number Input -->
            <div class="form-group col-md-6 mb-1 my-3">
              <label class="text-secondary text-xxs">Question Number<span class="text-danger">*</span></label>
              <input type="text" class="form-control text-xxs rounded p-2 bg-white" v-model="editQuestion.question_number" placeholder="Eg. 1" />
            </div>

            <!-- Question Type Select -->
            <div class="form-group col-md-6 mb-1 my-3">
              <label class="text-secondary text-xxs">Type<span class="text-danger">*</span></label>
              <select v-model="editQuestion.type" class="form-select text-xxs p-2 rounded">
                <option value="" disabled>Select</option>
                <option v-for="type in question_types" :key="type.id" :value="type.id">
                  {{ type.question_type }}
                </option>
              </select>

              <!-- Options -->
              <div v-for="(option, index) in editQuestion.options"
                  :key="index"
                  v-if="editQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === editQuestion.type)?.question_type)"
                  class="d-flex align-items-center mb-2 mt-2">
                <input type="text"
                      class="form-control text-xxs rounded p-2 me-2"
                      v-model="option.text"
                      placeholder="Enter option text" />
                <button class="btn btn-danger btn-sm text-xxs" type="button" @click="editQuestion.options.splice(index, 1)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>

              <div v-if="editQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === editQuestion.type)?.question_type)">
                <button class="btn btn-warning text-white mt-3 text-xxs rounded shadow-lg fw-500" type="button" @click="editQuestion.options.push({ text: '' })">
                  <i class="bi bi-plus"></i> Add Question Option
                </button>
              </div>
            </div>
            <div class="form-group col-md-6 mb-1 my-3">
            <label class="text-secondary text-xxs">Is the question locked?</label>
            <select v-model="editQuestion.is_locked" class="form-select text-xxs p-2 rounded">
              <option :value="true">Yes</option>
              <option :value="false">No</option>
            </select>
          </div>
            <!-- Mandatory -->
            <div class="form-group col-md-6 mb-1 my-3">
              <label class="text-secondary text-xxs">Is the question mandatory?</label>
              <select v-model="editQuestion.is_mandatory" class="form-select text-xxs p-2 rounded">
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary text-white text-xxs rounded shadow-lg fw-500 float-end"
            @click="submitEditQuestion">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>
